import * as React from 'react'
import { Toolbar } from '@base-ui/react/toolbar'
import { Button } from '../../button'
import type { PartProps } from '../../../lib/part-props'

type ActionPopoverButtonProps = PartProps<Omit<React.ComponentProps<typeof Button>, 'shape'>> & {
  shape?: 'rounded' | 'circle'
}

function ActionPopoverButton({
  variant,
  size = 'sm',
  shape = 'rounded',
  loading,
  left,
  right,
  className,
  children,
  ...props
}: ActionPopoverButtonProps) {
  return (
    <Toolbar.Button
      render={
        <Button variant={variant} size={size} shape={shape} loading={loading} left={left} right={right} {...props} />
      }
      className={className}
      tabIndex={-1}
    >
      {children}
    </Toolbar.Button>
  )
}

export { ActionPopoverButton }
